<button data-cy="report-button__reports-button-btn" mat-stroked-button (click)="openReportDialog()" style="margin-bottom: 0px;" class="reports-button">
  <i class="uil uil-file-export unicon-icon d-text-middle"></i>
  <span class="hidden-xs hidden-sm">{{'report.labels' | transloco | capitaliz}}</span>
</button>
